import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5da1b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center gap-4 mb-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Translate from", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Translate to", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "el-upload-list__item-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import { ref, reactive, computed } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import type { UploadInstance, UploadUserFile, UploadFile } from "element-plus";
import SupportService from "../services/SupportService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Delete, Plus, ZoomIn } from "@element-plus/icons-vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReplyCase',
  props: {
    item: {}
  },
  emits: ["replied"],
  setup(__props: any, { emit: emits }) {

const props = __props;


const fileList = ref<UploadUserFile[]>([]);
const caseId = computed(() => props.item.id);
const item = computed(() => props.item);
const uploading = ref(false);
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const uploadRef = ref<UploadInstance>();
const gUids = ref<any>([]);
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const disabled = ref(false);
const rules = reactive<FormRules>({
  content: [
    { required: true, message: "Please input content", trigger: "blur" },
  ],
});
const formData = ref<any>({
  categoryId: 1,
  content: "",
  mediumGuids: gUids.value,
});


const handlePictureCardPreview = (file: UploadFile) => {
  if (file.url) {
    dialogImageUrl.value = file.url;
    dialogVisible.value = true;
  } else {
    MsgPrompt.error("No preview available");
  }
};

const handleRemove = (file: UploadFile) => {
  const index = fileList.value.indexOf(file);
  fileList.value.splice(index, 1);
};

const uploadImage = async (file?: any) => {
  const formData = new FormData();
  formData.append("file", file.raw);
  try {
    const res = await SupportService.uploadCaseFile("case", formData);
    gUids.value.push(res.guid);
  } catch (error) {
    MsgPrompt.error("Upload file failed, file too large or invalid format");
  }
};

const processUpload = async () => {
  uploading.value = true;
  for (let i = 0; i < fileList.value.length; i++) {
    const file = fileList.value[i];
    await uploadImage(file);
  }
  uploading.value = false;
};
const resetForm = () => {
  ruleFormRef.value?.resetFields();
  fileList.value = [];
  gUids.value = [];
  formData.value = {
    categoryId: 1,
    content: "",
    mediumGuids: gUids.value,
  };
};
const submitForm = async (formEl: FormInstance | undefined) => {
  isLoading.value = true;
  try {
    await formEl?.validate(async (valid, fields) => {
      if (valid) {
        await processUpload().then(() => {
          SupportService.replyCaseById(caseId.value, formData.value).then(
            () => {
              uploadRef.value?.clearFiles();
              resetForm();
              isLoading.value = false;
              MsgPrompt.success("Case Replied");
              emits("replied");
            }
          );
        });
      }
    });
  } catch (e) {
    MsgPrompt.error("Case Reply failed");
    isLoading.value = false;
    console.log(e);
  }

  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    model: formData.value,
    rules: rules,
    "label-position": "top",
    class: "px-5 py-10"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_select, {
          modelValue: formData.value.sourceLanguage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.sourceLanguage) = $event)),
          class: "w-200px",
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.name,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_3,
        _createVNode(_component_el_select, {
          modelValue: formData.value.targetLanguage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.targetLanguage) = $event)),
          class: "w-200px",
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.name,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_form_item, {
        label: "Content",
        prop: "content",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.value.content,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.content) = $event)),
            autosize: { minRows: 6, maxRows: 10 },
            type: "textarea"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "Upload" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "list-type": "picture-card",
            limit: 5,
            "auto-upload": false,
            "http-request": uploadImage,
            multiple: "",
            "file-list": fileList.value,
            "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((fileList).value = $event))
          }, {
            file: _withCtx(({ file }) => [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  class: "el-upload-list__item-thumbnail",
                  src: file.url,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "el-upload-list__item-preview",
                    onClick: ($event: any) => (handlePictureCardPreview(file))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ZoomIn))
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_6),
                  (!disabled.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "el-upload-list__item-delete",
                        onClick: ($event: any) => (handleRemove(file))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Plus))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list"]),
          _createElementVNode("div", null, [
            (dialogVisible.value)
              ? (_openBlock(), _createBlock(_component_el_image_viewer, {
                  key: 0,
                  "url-list": [dialogImageUrl.value],
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = false))
                }, null, 8, ["url-list"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(ruleFormRef.value))),
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})